export enum HttpStatusCode {
  Success = '0000',
  Timeout = '3001',
  ServiceException = '5001',
  ServiceError = '4001',
}

export enum Method {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
}
